export const verticalCentering = `
    display: flex;
    align-items: center;
    justify-content: center;
`;
